import PropTypes from "prop-types";

import { S3Video } from "@app/components/S3Video";
import { S3Image } from "@app/components/S3Image";

import { style } from "@react-spectrum/s2/style" with { type: "macro" };

const VIDEO_EXTENSIONS = new Set(["mp4", "webm", "mov", "m4v", "ogv"]);

const isVideoPath = (path) => {
  if (!path) return false;
  const ext = path.split("?")[0].split("#")[0].split(".").pop()?.toLowerCase();
  return !!ext && VIDEO_EXTENSIONS.has(ext);
};

export const S3Asset = ({
  filePath,
  alt,
  src,
  type,
  color,
  width,
  height,
  isLoading,
}) => {
  const resolvedType =
    type ?? (isVideoPath(filePath) || isVideoPath(src) ? "video" : undefined);

  if (resolvedType === "video") {
    return (
      <S3Video
        filePath={filePath}
        src={src}
        isLoading={isLoading}
        className={style({
          display: "block",
          objectFit: "cover",
          width: "full",
          aspectRatio: "16 / 9",
        })}
      />
    );
  }

  if (resolvedType === "color") {
    return (
      <div
        role="img"
        aria-label={alt}
        className={style({
          display: "block",
          width: "full",
          aspectRatio: "square",
          borderRadius: "default",
        })}
        style={{
          backgroundColor: color || undefined,
          backgroundImage: color
            ? undefined
            : "linear-gradient(to bottom right, transparent calc(50% - 1px), var(--spectrum-gray-400) calc(50% - 1px) calc(50% + 1px), transparent calc(50% + 1px))",
        }}
      />
    );
  }

  return (
    <S3Image
      alt={alt}
      filePath={filePath}
      src={src}
      isLoading={isLoading}
      styles={style({ objectFit: "cover" })}
      UNSAFE_style={
        width && height ? { aspectRatio: `${width} / ${height}` } : undefined
      }
    />
  );
};

S3Asset.propTypes = {
  filePath: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
  type: PropTypes.oneOf(["image", "video", "color"]),
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  isLoading: PropTypes.bool,
};
